import React, { useState, useEffect } from 'react';
import { soundService } from '../services/sound';
import styles from "../styles/ToggleButton.module.css"

interface AudioToggleButtonProps {
  className?: string;
}

const AudioToggleButton: React.FC<AudioToggleButtonProps> = ({ className = '' }) => {
  const [isAudioEnabled, setIsAudioEnabled] = useState(soundService.isAudioEnabled());

  useEffect(() => {
    // Sync with sound service state
    setIsAudioEnabled(soundService.isAudioEnabled());
  }, []);

  const toggleAudio = () => {
    const newState = !isAudioEnabled;
    soundService.setEnabled(newState);
    setIsAudioEnabled(newState);
  };

  return (
    <button
      className={`${styles.toggleButton} ${className}`}
      onClick={toggleAudio}
      title={isAudioEnabled ? 'Disable sound effects' : 'Enable sound effects'}
      aria-label={isAudioEnabled ? 'Disable sound effects' : 'Enable sound effects'}
    >
      {isAudioEnabled ? (
        // Speaker icon (enabled)
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M3 9V15H7L12 20V4L7 9H3Z" 
            fill="currentColor"
          />
          <path 
            d="M16.5 12C16.5 10.23 15.48 8.71 14 7.97V16.02C15.48 15.29 16.5 13.77 16.5 12Z" 
            fill="currentColor"
          />
          <path 
            d="M14 3.23V5.29C16.89 6.15 19 8.83 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.72 18.01 4.14 14 3.23Z" 
            fill="currentColor"
          />
        </svg>
      ) : (
        // Muted speaker icon (disabled)
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M3 9V15H7L12 20V4L7 9H3Z" 
            fill="currentColor"
          />
          <path 
            d="M16.5 12L14.5 10L16.5 8L18.5 10L20.5 8L22.5 10L20.5 12L22.5 14L20.5 16L18.5 14L16.5 16L14.5 14L16.5 12Z" 
            fill="currentColor"
          />
        </svg>
      )}
    </button>
  );
};

export default AudioToggleButton;